module.exports = __webpack_public_path__ + "img/tipimg_g@2x.e83d942b.png";